/**
 * Copies text to the clipboard, falling back to a hidden textarea where the async API is unavailable.
 *
 * @param {string} value
 * @returns {Promise<boolean>} Whether the text was copied.
 */
export async function copyToClipboard(value) {
    if (!value) {
        return false;
    }

    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(value);

            return true;
        } catch {
            // Fall through to the legacy path.
        }
    }

    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', 'readonly');
    field.style.position = 'absolute';
    field.style.left = '-9999px';
    document.body.appendChild(field);
    field.select();

    try {
        return document.execCommand('copy');
    } catch {
        return false;
    } finally {
        field.remove();
    }
}
